import Vue from "vue";
import { ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/modules/general/types";
import { AxiosResponse } from "axios";
import { AT_MENU } from './types';

type ModuleActionContext = ActionContext<any, RootState>;
type ModuleActionTree = ActionTree<any, RootState>;

export const actions: ModuleActionTree = {
  async getMenu(): Promise<AT_MENU[] | undefined> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Main/Menu"
      });
      return response.data;
    } catch (e) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
  async getConfiguracionGeneral(): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Main/Configuracion"
      });
      return response.data;
    } catch (e) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
  async getComprasMesActual(): Promise<Record<string, string> | undefined> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Main/GetComprasMesActual"
      });
      return response.data;
    } catch (e) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
  async checkArticuloPermitido(context: ModuleActionContext, payload: object): Promise<boolean> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Articulo/CheckArticuloPermitido",
        params: payload
      });
      return response.data;
    } catch (e) {
      return false;
    }
  },
  async postRegistrarFeedback(context: ModuleActionContext, payload: object): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "POST",
        url: "/Soporte/RegistrarFeedback",
        data: payload,
      });
      return response.data;
    } catch (e) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
  async GetImageUrl(context: ModuleActionContext, payload: object): Promise<boolean> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Main/GetImageUrl",
        params: payload
      });
      return response.data;
    } catch (e) {
      return false;
    }
  },
};
